import TopBanner from './TopBanner';

export default TopBanner;
